import { render, staticRenderFns } from "./orderDetailPart.vue?vue&type=template&id=0272884e&scoped=true"
import script from "./orderDetailPart.vue?vue&type=script&lang=js"
export * from "./orderDetailPart.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./orderDetailPart.vue?vue&type=style&index=0&id=0272884e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0272884e",
  "4359a921"
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageList: require('/Users/wu67/Projects/uk_front/components/imageList.vue').default,ExportDialog: require('/Users/wu67/Projects/uk_front/components/ExportDialog.vue').default})
